import {InjectionToken} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {Observable} from 'rxjs';

export interface IconRegistry {
  getIcon(name: string): Observable<SafeHtml> | undefined;
}

export const ICON_REGISTRY_SERVICE = new InjectionToken<IconRegistry>(
  'Provides service for icon registry',
);
